import { useDispatch, useSelector } from "react-redux";

import { startFetch, startFetchExcel, startFetchPdf } from "../../services/fetch/startFetch";
import { finishSpinner } from "../../actions/ui/spinner";
import { startAlerta } from "../../actions/ui/alertas";
import totemService from "../../services/totemService";
import {
    cleanAfiliadosTotem,
    cleanOpcionesTotem,
    cleanRecepcionesTotem,
    cleanRecepcionesUsuarioTotem,
    cleanSolicitudesAfiliadosTotem,
    cleanSolicitudesRecepcionesUsuarioTotem,
    cleanSubOpcionesTotem,
    cleanTurnosAfiliadosTotem,
    confirmTurnosAfiliadoTotem,
    deleteOpcionTotem,
    deleteRecepcionTotem,
    deleteSubOpcionTotem,
    getAfiliadosTotem,
    getOpcionesTotem,
    getRecepcionesPisos,
    getRecepcionesTotem,
    getRecepcionesUsuarioTotem,
    getSolicitudesAfiliadosTotem,
    getSolicitudesRecepcionesUsuarioTotem,
    getSubOpcionesTotem,
    getTurnosAfiliadosTotem,
    insertOpcionTotem,
    insertRecepcionTotem,
    insertSolicitudRecepcionUsuarioTotem,
    insertSubOpcionTotem,
    updateOpcionTotem,
    updateRecepcionTotem,
    updateSolicitudAfiliadoTotem,
    updateSubOpcionTotem,
} from "../../reducers/totem/totemActions";

export const useTotem = () => {
    const dispatch = useDispatch();

    const clean = {
        opciones: () => { dispatch(cleanOpcionesTotem()) },
        subOpciones: () => { dispatch(cleanSubOpcionesTotem()) },
        recepciones: () => { dispatch(cleanRecepcionesTotem()) },
        recepcionesUsuario: () => { dispatch(cleanRecepcionesUsuarioTotem()) },
        solicitudesRecepcionesUsuario: () => { dispatch(cleanSolicitudesRecepcionesUsuarioTotem()) },
        solicitudesAfiliados: () => { dispatch(cleanSolicitudesAfiliadosTotem()) },
        afiliados: () => { dispatch(cleanAfiliadosTotem()) },
        turnosAfiliados: () => { dispatch(cleanTurnosAfiliadosTotem()) },
    }

    const get = {
        opciones: () => {
            dispatch(startFetch(
                () => totemService.getOpciones(),
                (values) => {
                    dispatch(getOpcionesTotem(values));
                })
            );
        },
        subOpciones: () => {
            dispatch(startFetch(
                () => totemService.getSubOpciones(),
                (values) => {
                    dispatch(getSubOpcionesTotem(values));
                })
            );
        },
        recepciones: () => {
            dispatch(startFetch(
                () => totemService.getRecepciones(),
                (values) => {
                    dispatch(getRecepcionesTotem(values));
                })
            );
        },
        recepcionesUsuarios: () => {
            dispatch(startFetch(
                () => totemService.getRecepcionesUsuario(),
                (values) => {
                    dispatch(getRecepcionesUsuarioTotem(values));
                })
            );
        },
        recepcionesPisos: () => {
            dispatch(startFetch(
                () => totemService.getRecepcionesPisos(),
                (values) => {
                    dispatch(getRecepcionesPisos(values));
                })
            );
        },
    };

    const getById = {
        solicitudesRecepcionesUsuario: () => {
            dispatch(startFetch(
                () => totemService.getByIdSolicitudesRecepcionesUsuario(),
                (values) => {
                    dispatch(getSolicitudesRecepcionesUsuarioTotem(values));
                })
            );
        },
        turnosAfiliados: (id, callback) => {
            dispatch(startFetch(
                () => totemService.getTurnosAfiliados(id),
                (values) => {
                    dispatch(getTurnosAfiliadosTotem(values));
                    callback(values);
                })
            );
        },
    }

    const getByParameters = {
        afiliado: (parameters) => {
            dispatch(startFetch(
                () => totemService.getAfiliado(parameters),
                (value) => {
                    dispatch(getAfiliadosTotem([value]));
                })
            );
        },
    }

    const search = {
        solicitudesRecepcionesUsuario: (parameters) => {
            dispatch(startFetch(
                () => totemService.getSolicitudesAfiliados(parameters),
                (values) => {
                    dispatch(getSolicitudesAfiliadosTotem(values));
                },
                false
            ));
        },
    }

    const insert = {
        opcion: (data, values) => {
            dispatch(startFetch(
                () => totemService.insertOpcion(data),
                (id) => {
                    dispatch(insertOpcionTotem({ ...values, id }));
                    dispatch(startAlerta(`Opción Agregada`, 'success', 'Comando Exitoso'));
                })
            );
        },
        subOpcion: (data, values) => {
            dispatch(startFetch(
                () => totemService.insertSubOpcion(data),
                (id) => {
                    dispatch(insertSubOpcionTotem({ ...values, id }));
                    dispatch(startAlerta(`Sub Opción Agregada`, 'success', 'Comando Exitoso'));
                })
            );
        },
        recepcion: (data, values) => {
            dispatch(startFetch(
                () => totemService.insertRecepcion(data),
                (id) => {
                    dispatch(insertRecepcionTotem({ ...values, id }));
                    dispatch(startAlerta(`Recepción Agregada`, 'success', 'Comando Exitoso'));
                })
            );
        },
        solicitudesRecepcionesUsuario: (data) => {
            dispatch(startFetch(
                () => totemService.insertSolicitudRecepcionUsuario(data),
                (values) => {
                    dispatch(insertSolicitudRecepcionUsuarioTotem(values));
                    dispatch(startAlerta(`Solicitud Agregada`, 'success', 'Comando Exitoso'));
                })
            );
        },
        solicitudesAfiliado: (data) => {
            dispatch(startFetch(
                () => totemService.insertSolicitudAfiliado(data),
                () => { dispatch(finishSpinner()); })
            );
        },
        solicitudesAfiliadoRecepcionista: (data, handleReset) => {
            dispatch(startFetch(
                () => totemService.insertSolicitudAfiliadoRecepcionista(data),
                () => {
                    handleReset();
                    clean.afiliados();
                    dispatch(startAlerta(`Solicitud Confirmada`, 'success', 'Comando Exitoso'));
                })
            );
        },
        confirmTurnoAfiliado: (sendData, data, handleClose) => {
            dispatch(startFetch(
                () => totemService.confirmTurnoAfiliado(sendData),
                () => {
                    dispatch(confirmTurnosAfiliadoTotem(data));
                    dispatch(startAlerta(`Turno Confirmado`, 'success', 'Comando Exitoso'));
                    handleClose();
                })
            )
        },
        recepcionesPisos: (data) => {
            dispatch(startFetch(
                () => totemService.insertRecepcionPiso(data),
                (values) => {
                    dispatch(startAlerta(`Agregado Correctamente`, 'success', 'Comando Exitoso'));
                    get.recepcionesPisos(); 
                })
            );
        },
    };

    const update = {
        opcion: (data, values) => {
            dispatch(startFetch(
                () => totemService.updateOpcion(data),
                () => {
                    dispatch(updateOpcionTotem(values));
                    dispatch(startAlerta(`Opción Modificada`, 'success', 'Comando Exitoso'));
                })
            );
        },
        subOpcion: (data, values) => {
            dispatch(startFetch(
                () => totemService.updateSubOpcion(data),
                () => {
                    dispatch(updateSubOpcionTotem(values));
                    dispatch(startAlerta(`Sub Opción Modificada`, 'success', 'Comando Exitoso'));
                })
            );
        },
        recepcion: (data, values) => {
            dispatch(startFetch(
                () => totemService.updateRecepcion(data),
                () => {
                    dispatch(updateRecepcionTotem(values));
                    dispatch(startAlerta(`Recepción Modificada`, 'success', 'Comando Exitoso'));
                })
            );
        },
        solicitudesRecepcionesUsuario: (data, values) => {
            dispatch(startFetch(
                () => totemService.confirmSolicitudRecepcionUsuario(data),
                () => {
                    dispatch(updateRecepcionTotem(values));
                    dispatch(startAlerta(`Solicitud Confirmada`, 'success', 'Comando Exitoso'));
                })
            )
        },
        confirmSolicitudAfiliado: (data, values) => {
            dispatch(startFetch(
                () => totemService.confirmSolicitudAfiliado(data),
                () => {
                    dispatch(updateSolicitudAfiliadoTotem(values));
                    dispatch(startAlerta(`Solicitud Confirmada`, 'success', 'Comando Exitoso'));
                })
            )
        },
        recepcionesPisos: (data) => {
            dispatch(startFetch(
                () => totemService.updateRecepcionPiso(data),
                (values) => {
                    dispatch(startAlerta(`Actualizada correctamente`, 'success', 'Comando Exitoso'));
                    get.recepcionesPisos(); 
                })
            );
        },
    };

    const remove = {
        opcion: (id) => {
            dispatch(startFetch(
                () => totemService.deleteOpcion({ id }),
                () => {
                    dispatch(deleteOpcionTotem(id));
                    dispatch(finishSpinner());
                    dispatch(startAlerta(`Opción Eliminada`, 'success', 'Comando Exitoso'));
                })
            );
        },
        subOpcion: (id) => {
            dispatch(startFetch(
                () => totemService.deleteSubOpcion({ id }),
                () => {
                    dispatch(deleteSubOpcionTotem(id));
                    dispatch(finishSpinner());
                    dispatch(startAlerta(`Sub Opción Eliminada`, 'success', 'Comando Exitoso'));
                })
            );
        },
        recepcion: (id) => {
            dispatch(startFetch(
                () => totemService.deleteRecepcion({ id }),
                () => {
                    dispatch(deleteRecepcionTotem(id));
                    dispatch(finishSpinner());
                    dispatch(startAlerta(`Recepción Eliminada`, 'success', 'Comando Exitoso'));
                })
            );
        },
        solicitudesRecepcionesUsuario: (data, values) => {
            dispatch(startFetch(
                () => totemService.rejectSolicitudRecepcionUsuario(data),
                () => {
                    dispatch(updateRecepcionTotem(values));
                    dispatch(finishSpinner());
                    dispatch(startAlerta(`Solicitud Eliminada`, 'success', 'Comando Exitoso'));
                })
            );
        }
    };

    const files = {
        solicitudesAfiliados: {
            get: (parameters) => {
                dispatch(startFetch(
                    () => totemService.getSolicitudesAfiliadosFiles(parameters),
                    (values) => {
                        dispatch(getSolicitudesAfiliadosTotem(values));
                        dispatch(finishSpinner());
                    })
                );
            },
            excel: (parameters) => {
                dispatch(startFetchExcel(
                    () => totemService.excelSolicitudesAfiliadosFiles(parameters),
                    "Totem-SolicitudesAfiliados.xlsx"
                ));
            },
            pdf: (parameters) => {
                dispatch(startFetchPdf(
                    () => totemService.pdfSolicitudesAfiliadosFiles(parameters)
                ));
            },
        }
    }

    return {
        get,
        getById,
        getByParameters,
        search,
        insert,
        update,
        remove,
        clean,
        files,
        data: useSelector((state) => state.totem)
    };
}